<mat-toolbar class="header mat-elevation-z4 v-middle">
    <span class="title-group">
        <a>
            <i class="material-icons">
                commute
            </i>
            PedPag
        </a>
    </span>
</mat-toolbar>